import { render, staticRenderFns } from "./EmailCustomers.vue?vue&type=template&id=eb287bd2"
import script from "./EmailCustomers.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailCustomers.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports